import React, { useContext } from 'react';
import styled from 'styled-components';
import { components } from 'react-select';
import { SearchableSelectContext } from '../SearchableSelect';
import cx from 'classnames';
import useTranslation from '../../../../util/hooks/useTranslation';

export const Dropdown = ({ className, children, isOpen, target, onClose }) => (
    <div className={cx(className, 'select-dropdown')}>
        {target}
        {isOpen ? <Menu>{children}</Menu> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
);
export const Menu = props => {
    return <div className={'select-menu'} {...props} />;
};
export const Blanket = props => <div className={'select-blanket'} {...props} />;

export const Svg = p => <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation" {...p} />;

export const DropdownIndicator = () => (
    <div className={'select-dropdown-indicator'}>
        <Svg>
            <path
                d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </Svg>
    </div>
);

export const Option = function ({ label, isSelected, ...restProps }) {
    return (
        <div className={'select-option'}>
            <components.Option className={'d-flex'} {...restProps}>
                <label className={'pnt-checkbox h-auto align-center'} title={label}>
                    <input type="checkbox" checked={isSelected} onChange={e => null} />
                    <span className={'material-icons-round md-18'}>check_box_outline_blank</span>
                    <p>{label}</p>
                </label>
            </components.Option>
        </div>
    );
};
export const Control = ({ children, options, ...restProps }) => {
    // console.log(restProps);
    return options.length > 10 ? (
        <components.Control
            className={'select-control'}
            {...restProps}
            options={options}
            // innerProps={{
            //     onMouseDown: e => {
            //         console.log('mousedown');
            //     },
            //     onTouchEnd: e => {
            //         console.log('touchend');
            //     },
            // }}
        >
            {children}
        </components.Control>
    ) : null;
};

export const ValueContainerText = ({ title, labelKey, selected, options }) => {
    const t = useTranslation('TreeSelect');
    const selectedLength = selected ? selected.length : 0;
    const optionsLength = options ? options.length : 0;
    return !selectedLength || selectedLength === optionsLength ? (
        <strong>
            {title} : {t('All')}
        </strong>
    ) : selectedLength === 1 ? (
        <strong>{selected[0][labelKey]}</strong>
    ) : (
        <>
            <strong>{selected[0][labelKey]}</strong>
            <span>
                &nbsp;{t('other')} {selectedLength - 1}
            </span>
        </>
    );
};

export const ValueContainer = ({ selected, onClick, isOpen, title, labelKey, options }) => {
    return (
        <StyledContainer onClick={onClick} isOpen={isOpen}>
            <div className={cx('select-container', isOpen && 'container-open')}>
                <div>
                    <ValueContainerText title={title} labelKey={labelKey} selected={selected} options={options} />
                </div>
                <div>
                    <span className="material-icons-round">arrow_drop_down</span>
                </div>
            </div>
        </StyledContainer>
    );
};

export const MenuList = ({ children, getValue, setValue, options, ...restProps }) => {
    const selected = getValue();
    const t = useTranslation('TreeSelect');
    const { valueKey, labelKey } = useContext(SearchableSelectContext);
    const handleChange = e => {
        const { checked } = e.currentTarget;
        setValue(checked ? options : []);
    };
    return (
        <components.MenuList {...restProps}>
            <div className={'mb-2'}>
                <div className={'select-group-title'}>{t('Selected')}</div>
                {selected.length ? (
                    selected.map(v => (
                        <div
                            className={'styled-option d-flex'}
                            key={v[valueKey]}
                            onClick={e => {
                                setValue(selected.filter(selectedOption => selectedOption[valueKey] !== v[valueKey]));
                            }}
                        >
                            <label className="pnt-checkbox h-auto" htmlFor={v[labelKey]}>
                                <input
                                    id={v[labelKey]}
                                    type="checkbox"
                                    style={{ cursor: 'pointer' }}
                                    value={v[valueKey]}
                                    checked
                                    onChange={() => null}
                                />
                                <span className="material-icons-round md-18 color-secondary">check_box</span>
                                <p>{v[labelKey]}</p>
                            </label>
                        </div>
                    ))
                ) : (
                    <div className={'styled-option-label'}>{t('Not Selected')}</div>
                )}
            </div>
            <div>
                <div className={'select-group-title pt-0 pb-0'}>
                    <label className="pnt-checkbox h-auto align-center" htmlFor={'All'}>
                        <input
                            id={'All'}
                            type="checkbox"
                            onChange={handleChange}
                            checked={selected.length === options.length}
                        />
                        <span
                            className={`material-icons-round md-18 ${
                                selected.length === options.length ? 'color-secondary' : ''
                            }`}
                        >
                            {selected.length === options.length ? 'check_box' : 'check_box_outline_blank'}
                        </span>
                        <p>{t('All')}</p>
                    </label>
                </div>
                {children}
            </div>
        </components.MenuList>
    );
};

export const StyledContainer = styled.div`
    position: relative;
    box-sizing: border-box;
    min-width: 9rem;
    //max-width: 14rem;
    width: 100%;
    & > div:hover {
        border-color: hsl(0, 0%, 70%);
    }
    & > div {
        align-items: center;
        background-color: hsl(0, 0%, 100%);
        border: ${props => (props.isOpen ? '1px solid #2684ff' : '1px solid hsl(0, 0%, 80%)')};
        box-shadow: ${props => props.isOpen && '0 0 0 1px #2684ff'};
        border-radius: 2px;
        cursor: pointer;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        min-height: 28px;
        outline: 0 !important;
        position: relative;
        transition: all 100ms;
        box-sizing: border-box;

        div:first-child {
            align-items: center;
            display: flex;
            flex: 1;
            flex-wrap: wrap;
            padding: 2px 8px;
            position: relative;
            overflow: hidden;
            box-sizing: border-box;
        }
        div:last-child {
            align-items: center;
            align-self: stretch;
            display: flex;
            flex-shrink: 0;
            padding: 6px;
            -webkit-transition: color 150ms;
            transition: color 150ms;
            span {
                font-size: 1rem;
                box-sizing: border-box;
                align-self: stretch;
            }
            div {
                color: hsl(0, 0%, 80%);
                display: flex;
                box-sizing: border-box;
                span {
                    display: inline-block;
                    fill: currentColor;
                    line-height: 1;
                    stroke: currentColor;
                    stroke-width: 0;
                }
            }
            div:hover {
                color: hsl(0, 0%, 60%);
            }
        }
    }
`;
